/**
 * @param string className
 * @param object postData
 * @param function callback
 * @param function callbackFail
 * @returns {undefined} */
function AjaxHandlerByClass(className, postData, callback, callbackFail) {
    postData.sid = sid;
    var timestamp = new Date().getTime();

    var me = this;

    $.ajax(
        {
            contentType: "application/json; charset=utf-8",
            url: className + '?ts=' + timestamp + '&sid=' + sid,
            type: 'post',
            data: JSON.stringify(postData),
            dataType: 'json',
            cache: false,
            success:  function (data) {
                if (data)
                    if (data.responseJSON || data.debug) {
                        if (data.debug)
                            var debug = data.debug;
                        else if (data.responseJSON && data.responseJSON.debug)
                            var debug = data.responseJSON.debug;
                        if (window.console) {
                            for (var key in debug) {
                                if (debug.hasOwnProperty(key)) {
                                    //    console.log(debug[key]);
                                }
                            }
                        }

                    }
                    callback(data);
            },
            error: function (data) {
                if (data)
                    if (data.responseJSON || data.debug) {
                        if (data.debug)
                            var debug = data.debug;
                        else if (data.responseJSON && data.responseJSON.debug)
                            var debug = data.responseJSON.debug;
                        if (window.console) {
                            for (var key in debug) {
                                if (debug.hasOwnProperty(key)) {
                                    //    console.log(debug[key]);
                                }
                            }
                        }

                    }
                callbackFail(data);
            }
        }
    );
}

/**
 * Calls the backend handler with extjs interface handling.
 * @param {type} className
 * @param {type} postData
 * @param {type} okMessage
 * @param {type} failMessage
 * @param {type} progressMessage
 * @returns {undefined}
 */
function BackendCall(className, postData, okMessage, failMessage, progressMessage) {
    if (progressMessage) {
        classicInfoMessage(progressMessage);
    }
    AjaxHandlerByClass(className, postData, function () {
        classicInfoMessage(okMessage)
    }, function () {
        classicErrrorMessage(failMessage)
    });
}


/**
 * displays the progress message.
 *
 * @param {type} text
 * @returns {undefined}
 */
function classicErrrorMessage(text) {
    if (text)
        notification.error(text)
}


function classicInfoMessage(text) {
    if (text)
        notification.info(text)
}

function deleteCache(callback) {
    AjaxHandlerByClass(
        'ajax/Administration/System/deleteCache', {},
        function (data) {
            notification.result(data.result[0]);
            if (data.info)
                notification.info(data.info[0]);
            if ($.isFunction(callback))
                callback();

            localStorage.clear();
            notification.info("Cleared Local Storage!");
        });
}